const palette: {
  [key: string]: { color: string; fontColor: 'white' | 'black' };
} = {
  white: { color: '#ffffff', fontColor: 'black' },
  red: { color: '#f44336', fontColor: 'white' },
  pink: { color: '#e91e63', fontColor: 'white' },
  purple: { color: '#9c27b0', fontColor: 'white' },
  deepPurple: { color: '#673ab7', fontColor: 'white' },
  indigo: { color: '#3f51b5', fontColor: 'white' },
  blue: { color: '#2196f3', fontColor: 'white' },
  lightBlue: { color: '#03a9f4', fontColor: 'white' },
  cyan: { color: '#00bcd4', fontColor: 'white' },
  teal: { color: '#009688', fontColor: 'white' },
  green: { color: '#4caf50', fontColor: 'white' },
  lightGreen: { color: '#8bc34a', fontColor: 'black' },
  lime: { color: '#cddc39', fontColor: 'black' },
  yellow: { color: '#ffeb3b', fontColor: 'black' },
  amber: { color: '#ffc107', fontColor: 'black' },
  orange: { color: '#ff9800', fontColor: 'black' },
  deepOrange: { color: '#ff5722', fontColor: 'white' },
  brown: { color: '#795548', fontColor: 'white' }
  // grey: { color: '#9e9e9e', fontColor: 'white' },
  // blueGrey: { color: '#607d8b', fontColor: 'white' }
};

export default palette;
